import * as React from "react";
import type { SVGProps } from "react";

/**
 * Gamepad Icon - 游戏手柄图标
 * Used for: Mini Games, Original Games categories
 */
const GamepadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={21}
    viewBox="0 0 48 48"
    {...props}
    fill={"#67707b"}
    fillRule={"evenodd"}
  >
    <path d="M23.5 44.007A19.505 19.505 0 1 1 43 24.5a19.5 19.5 0 0 1-19.5 19.507Zm1.747-3.407a16.1 16.1 0 0 0 8.206-3.333L31.4 35.216a13.228 13.228 0 0 1-6.153 2.484v2.9Zm-1.522-7.848h3.8l-3.8-3.716-3.8 3.716h3.8ZM21.743 40.6v-2.9a13.226 13.226 0 0 1-6.143-2.487l-2.051 2.052a16.1 16.1 0 0 0 8.194 3.335Zm-11-26.056a16.114 16.114 0 0 0-3.362 8.536h2.875a13.245 13.245 0 0 1 2.537-6.48Zm-.386 12.035h-2.9a16.126 16.126 0 0 0 3.576 8.244l2.042-2.043a13.257 13.257 0 0 1-2.718-6.201ZM21.743 8.4a16.108 16.108 0 0 0-8.566 3.627l2.041 2.042a13.243 13.243 0 0 1 6.525-2.769V8.4Zm1.982 5.985v.015l-7.587 7.426a4.507 4.507 0 0 0 .223 6.121c2.291 2.395 5.824 1.452 7.367-.215a5.12 5.12 0 0 0 7.367.215 4.507 4.507 0 0 0 .223-6.121L23.725 14.4v-.011ZM25.247 8.4v2.9a13.241 13.241 0 0 1 6.527 2.766l2.042-2.043A16.107 16.107 0 0 0 25.247 8.4Zm10.717 26.43a16.124 16.124 0 0 0 3.585-8.253h-2.9a13.258 13.258 0 0 1-2.722 6.211Zm.293-20.29-2.051 2.052a13.245 13.245 0 0 1 2.539 6.488h2.875a16.113 16.113 0 0 0-3.363-8.54Z" />
  </svg>
);

export default GamepadIcon;

